import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { trackWidgetClick } from './utils'
import { Anchor } from 'components/Anchor'

import type { IDocument } from './typings'

const documentIconPath =
  'https://storage.googleapis.com/belajar-fe-cdn-staging/images/CLWidgets/document_icon.png'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IDocument & { className?: string }
>(({ title, subtitle, className, url, trackerWidgetData }, ref) => (
  <Anchor href={url}>
    <a href={url} className="last:mb-0 mb-2 block">
      <div
        className={clsx(
          'widget-component',
          'rounded border border-subdued py-3 pr-4',
          'grid grid-cols-[64px_1fr]',
          'cursor-pointer',
          className
        )}
        ref={ref}
        onClick={() => trackWidgetClick(trackerWidgetData)}
      >
        <div className="w-6 self-start justify-self-center pt-1">
          <img
            src={documentIconPath}
            alt="document_icon"
            width="24"
            height="30"
          />
        </div>
        <div className="self-center">
          <Text className="mb-0 line-clamp-2" variant="body-bold">
            {title}
          </Text>
          {subtitle && (
            <Text
              variant="body-sm"
              className="mb-0 mt-[2px] line-clamp-2"
              color="subdued"
            >
              {subtitle}
            </Text>
          )}
        </div>
      </div>
    </a>
  </Anchor>
))

BaseWidget.displayName = 'Document'

export default BaseWidget
